module.exports = __webpack_public_path__ + "img/sensor_light.e0bf46ca.svg";